import React from 'react'
import './Intro.css';
import CTA from './CTA';
import IMAGEOFME from '../../assets/mdlpfp-optimized.jpg'
import HeaderSocials from './HeaderSocials';

const Intro = () => {
  return (
      <section id='intro'>
        <div className='container header__container'>
          <h5>Hola, I'm</h5>
          <h1>Miguel Disu-Lord</h1>
          <h5 className='text-light'>iOS & web engineer</h5>
          <HeaderSocials />
          <div className='imageOfMe'>
            <img src={IMAGEOFME} alt='This is me' />
          </div>
          <CTA />
          <a href="#contact" className='scroll__down'>Scroll down</a>
        </div>
      </section>
  )
}
export default Intro
